import PageTitle from "../MainContents/PageTitle/PageTitle";
import styled from 'styled-components';
import HrImg from '../../img/hr-maru.png';
import { device } from '../MainContents/Style/StyleDevice';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import Vol4 from "./Vol/Vol4";
import Vol3 from "./Vol/Vol3";
import Vol2 from "./Vol/Vol2";
import Vol1 from "./Vol/Vol1";

const Main =styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;
    @media ${device.mobile}{
        width: 100%;
        position: relative;
    }
`
const Header =styled.h2`
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`

const BlogTitle = styled.h3`
    padding: 10px;
    border-bottom: 2px solid #ffc966;
    width: 350px;
    margin-top: 50px;
`
const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;
const Blog: React.VFC = () => {
  return (
    <Main>
      <ScrollToTopOnMount />
         <Mt></Mt>
      <PageTitle title={'ブログ'}  englishText={'Blog'} />
      <p className='text-center text-2xl font-bold'>レッスンのようすや、日々の気付きなどをつづっています。</p>
      <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
      <BlogTitle>STEMON秦校だより　Vol.4</BlogTitle>
      <Vol4 />
      <BlogTitle>STEMON秦校だより　Vol.3</BlogTitle>
      <Vol3 />
      <BlogTitle>STEMON秦校だより　Vol.2</BlogTitle>
      <Vol2 />
      <BlogTitle>STEMON秦校だより　Vol.1</BlogTitle>
      <Vol1 />
    </Main>
  );
}
export default Blog;